export default "__VITE_PUBLIC_ASSET__2d2c2afa__"